import { useState } from "react";
import { channels, channelTips } from "@/mocks/home";

export default function WatchGuideSection() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText("家庭教师HITMAN REBORN");
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <section id="channels" className="section-anchor w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="reveal max-w-2xl">
          <span className="text-xs font-label tracking-[0.2em] text-accent-600">观看渠道 / WHERE TO WATCH</span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl text-foreground-950">
            在线观看入口与资源说明
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            下面整理了常被提及的播放渠道与两种常见资源类型。由于第三方渠道的资源与线路时常变动，
            本站只做信息整理与检索指引，不直接提供播放链接；建议先复制作品名，再到对应渠道中搜索。
          </p>
        </div>

        <div className="reveal mt-6 rounded-lg bg-secondary-50 border border-secondary-200 px-5 py-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
          <div className="flex-1">
            <p className="text-xs text-secondary-700 font-label">检索用作品名</p>
            <p className="mt-1 font-heading text-xl text-secondary-950">家庭教师HITMAN REBORN</p>
          </div>
          <button
            type="button"
            onClick={handleCopy}
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-secondary-500 text-background-50 text-sm whitespace-nowrap hover:bg-secondary-600 transition-colors"
          >
            <i className={copied ? "ri-check-line" : "ri-file-copy-line"} />
            {copied ? "已复制作品名" : "复制作品名"}
          </button>
        </div>

        <div className="reveal mt-8 grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {channels.map((c) => (
            <article key={c.name} className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-6 flex flex-col">
              <div className="flex items-start gap-4">
                <div className="shrink-0 w-12 h-12 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className={`${c.icon} text-2xl`} />
                </div>
                <div>
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-heading text-xl text-foreground-950">{c.name}</h3>
                    <span className="px-2.5 py-0.5 rounded-full text-xs bg-primary-100 text-primary-800">
                      {c.type}
                    </span>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                </div>
              </div>
              <ul className="mt-4 pt-4 border-t border-background-200 space-y-2">
                {c.notes.map((n) => (
                  <li key={n} className="flex gap-2 text-xs md:text-sm text-foreground-700">
                    <i className="ri-arrow-right-s-line text-primary-600 mt-0.5" />
                    {n}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="reveal mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {channelTips.map((t) => (
            <div key={t.title} className="rounded-lg bg-background-100 border border-background-200 p-5">
              <div className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${t.icon} text-xl`} />
              </div>
              <h3 className="mt-3 text-sm font-label text-foreground-900">{t.title}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{t.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}